export default "Isolation des sols (plancher bas) 2026 — Aides MPR + CEE | Solution Éco France";
